import { Switch } from 'antd'
import React from 'react'

function SmallToggle() {
  return (
    <Switch className='auf-toggle' size="small" defaultChecked />
  )
}

export default SmallToggle